import { render, staticRenderFns } from "./ComplaintsList.vue?vue&type=template&id=08419b3e&scoped=true&"
import script from "./ComplaintsList.vue?vue&type=script&lang=js&"
export * from "./ComplaintsList.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintsList.vue?vue&type=style&index=0&id=08419b3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08419b3e",
  null
  
)

export default component.exports